const AL = {
  ibanLength: 28,
};
export { AL };
